import * as React from "react";
import Canvas from "./canvas";
const Hair = require("!raw-loader!./shibafu528_svg/shibafu_hair.svg");
const Eyes = require("!raw-loader!./shibafu528_svg/shibafu_eyes.svg");
const Ectoplasm = require("!raw-loader!./shibafu528_svg/shibafu_ectoplasm.svg");
const Line = require("!raw-loader!./shibafu528_svg/shibafu_line.svg");

interface IProps {
  faceColor: string;
  hairColor: string;
  eyeColor: string;
  entityColor: string;
  canvasComponentRef: React.Ref<Canvas>;
}

interface IState extends React.ComponentState {
  hairSvg: string;
}

const defaultColor = {
  faceColor: "#ffeac6",
  hairColor: "#00ffff",
  eyeColor: "#ffffff",
  entityColor: "#ffffff"
};

export default class Shibafu extends React.Component<IProps, IState> {
  public render() {
    const width = 512;
    const height = 512;

    let hairSVG = Hair.default ? Hair.default : Hair;
    console.log("Hair:", Hair);
    hairSVG = hairSVG
      .replace(`data-reactroot=""`, `xmlns="http://www.w3.org/2000/svg"`)
      .replace(new RegExp(defaultColor.hairColor), this.props.hairColor);
    let eyesSVG = Eyes.default ? Eyes.default : Eyes;
    eyesSVG = eyesSVG
      .replace(`data-reactroot=""`, `xmlns="http://www.w3.org/2000/svg"`)
      .replace(new RegExp(defaultColor.eyeColor, "g"), this.props.eyeColor);
    let ectoplasmSVG = Ectoplasm.default ? Ectoplasm.default : Ectoplasm;
    ectoplasmSVG = ectoplasmSVG
      .replace(`data-reactroot=""`, `xmlns="http://www.w3.org/2000/svg"`)
      .replace(
        new RegExp(defaultColor.entityColor, "g"),
        this.props.entityColor
      );
    let lineSVG = Line.default ? Line.default : Line;
    lineSVG = lineSVG
      .replace(`data-reactroot=""`, `xmlns="http://www.w3.org/2000/svg"`)
      .replace(new RegExp(defaultColor.faceColor, "g"), this.props.faceColor);

    return (
      <Canvas
        ref={this.props.canvasComponentRef}
        width={width}
        height={height}
        updateCanvas={(context: CanvasRenderingContext2D) => {
          const hair = new Image();
          const eyes = new Image();
          const ectoplasm = new Image();
          const line = new Image();

          hair.onload = () => {
            eyes.onload = () => {
              ectoplasm.onload = () => {
                line.onload = () => {
                  context.clearRect(0, 0, width, height);
                  context.drawImage(hair, 0, 0, width, height);
                  context.drawImage(eyes, 0, 0, width, height);
                  context.drawImage(ectoplasm, 0, 0, width, height);
                  context.drawImage(line, 0, 0, width, height);
                };
                line.src = "data:image/svg+xml;base64," + btoa(lineSVG);
              };
              ectoplasm.src = "data:image/svg+xml;base64," + btoa(ectoplasmSVG);
            };
            eyes.src = "data:image/svg+xml;base64," + btoa(eyesSVG);
          };
          hair.src = "data:image/svg+xml;base64," + btoa(hairSVG);
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/shibafu.tsx